import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlogArticleDetail } from 'src/app/services/rest-api/rest-api';
import { transformClassesToStyles } from '../functions';

@Component({
  selector: 'libero-blog-full-article-content',
  templateUrl: './blog-full-article-content.component.html',
  styleUrls: ['./blog-full-article-content.component.scss'],
  standalone: false
})
export class BlogFullArticleContentComponent implements OnChanges {
  public sanitizedHtmlFreeText: SafeHtml | '' = '';
  public sanitizedHtmlPremiumContent: SafeHtml | null = null;

  @Input() public articleDetail?: BlogArticleDetail;
  @Input() public otherPosts: BlogArticleDetail[] = [];
  @Input() public errored = false;
  @Input() public loading = true;
  @Input() public showOtherPosts = false;

  public constructor(
    private sanitizer: DomSanitizer
  ) { }

  public ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes['articleDetail'] && changes['articleDetail'].currentValue && changes['articleDetail'].currentValue.freeContent) {
      this.sanitizedHtmlFreeText =
        this.sanitizer.bypassSecurityTrustHtml(
          transformClassesToStyles(changes['articleDetail'].currentValue.freeContent)
        );
    }
    if(changes && changes['articleDetail'] && changes['articleDetail'].currentValue && changes['articleDetail'].currentValue.premiumContent) {
      this.sanitizedHtmlPremiumContent =
        this.sanitizer.bypassSecurityTrustHtml(
          transformClassesToStyles(changes['articleDetail'].currentValue.premiumContent)
        );
    }
  }

  public clickArticleContent(event: MouseEvent | Event): void {
    let target = event.target as HTMLElement;

    while (target && target !== event.currentTarget) {
      if (target.classList.contains('editor-pexeso-card')) {
        target.classList.toggle('flipped');
        break;
      }
      target = target.parentElement!;
    }
  }
}
